import { shouldDisplayFinalPriceUpfront } from '../experiments/finalPriceUpfront';

/**
 * Determine if the user should experience the subscription drawer in the gig page
 * @returns {boolean} whether to display gig subscription drawer
 */
export const eligibleForSubscriptionDrawer = () => !shouldDisplayFinalPriceUpfront();
